export default {
  response: null,
};
